// Modern blockchain and financial imagery from Unsplash
export const images = {
  hero: "/hero.png",
  access: "/access.png",
  platform: "/distribution.png",
  ecosystem: "/ecosystem.png"
};